import { MailerService } from './../../../../../../services/shared/mailer.service';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Solicitud } from '../../../../../../interfaces/interface-bakend/ofertas-laborales/solicitudes.interface';
import { SolicitudesService } from '../../../../../../services/ofertas-laborales/solicitudes.service';
import { User } from '../../../../../../interfaces/interface-bakend/seguridad/users/user.interface';
import { ActividadesService } from '../../../../../../services/ofertas-laborales/actividades.service';
import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { UploadFileSolicitudComponent } from '../../../../common/upload-file-solicitud/upload-file-solicitud.component';
import { OfertasImageViewerComponent } from '../../../../common/ofertas-image-viewer/ofertas-image-viewer.component';
import { MediaService } from '../../../../../../services/shared/media.service';
import { CatalogoService } from '../../../../../../services/shared/catalogo.service';
import { GuiMsjService } from '../../../../../../services/shared/gui-msj.service';
import { Actividad } from '../../../../../../interfaces/interface-bakend/ofertas-laborales/actividad.interface';
import {
    APP_CONFIG_OFERTAS,
    IAppOfertas,
} from '../../../../../../app.config/app.config-ofertas';
import { Subscription } from 'rxjs';
import { UserEntreUser } from '@interfaces/interface-bakend/seguridad/users/user-entre-user.interface';
import { UserEntreUserService } from '@services/shared/user-entre-user.service';
import Swal from 'sweetalert2';
import { UsuarioService } from '@services/shared/usuario.service';
import { environment } from '@env/environment';
import { PdfExportService } from 'src/app/services/shared/pdf-export.service';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

//// Interfaces Inscripcion y DDJJ
import {
    InscripcionOs,
    Parentesco,
    Nacionalidad,
    Sexo,
    RegimenLaboral,
    TipoDocumento,
    EstadoCivil,
} from 'src/app/auth/inscripcion-os/interfaz-inscripcion-os/inscripcion-os-interface';
import {
    DeclaracionJurada
} from 'src/app/auth/inscripcion-os/interfaz-ddjj-os/ddjj-os-interface';

@Component({
    selector: 'app-bandeja-inscripciones',
    templateUrl: './bandeja-inscripciones.component.html',
    styleUrls: ['./bandeja-inscripciones.component.scss'],
})
export class BandejaInscripcionesComponent implements OnInit, OnDestroy {
    // Estados
    activarEnRevision: boolean = false;
    activarEnAuditoria: boolean = false;
    activarAprobar: boolean = false;
    activarRechazar: boolean = false;
    activarEnvio: boolean = false;
    activarCerrarModal: boolean = true;
    activarEnEspera: boolean = true;
    activarDeshacerAnulacion: boolean = false;

    flagDisableButtonApprove: boolean = true;
    flagCargaCorrecta: boolean = false;
    selectedFile: File;
    selectedFileName: string = '';
    value: number = 0;
    isActive: boolean = false;
    subscriptionAvance: Subscription;

    motivoRevision: string = '';
    motivoRechazo: string = '';
    motivoEnEspera: string = '';
    nombrePais: string;
    actividad: Actividad;
    solicitud: Solicitud;
    beneficiario: UserEntreUser;
    usuario: User;

    flagLoaded: boolean;
    flagSpinner: boolean = false;
    flagEnRevision: boolean = false;
    flagEnAuditoria: boolean = false;
    flagLabelAprobado: boolean = false;
    flagLabelRechazado: boolean = false;
    flagLabelPresentado: boolean = false;
    flagLabelEnEspera: boolean = false;

    isCheckedAprobar: boolean = false;
    isCheckedRechazar: boolean = false;
    isCheckedEnRevision: boolean = false;
    isCheckedEnviarDocumentos: boolean = false;
    isCheckedEnEspera: boolean = false;

    dataModal: any;

    estadoDocumentacion: string;

    imgs: string[] = [];
    files: string[] = [];
    nombresImagenes: { [key: string]: string } = {};

    adjuntoCatalogo: any;
    idioma: Subscription;
    newState: Subscription;

    habilitarEnviarObservacion: boolean = false;
    botonAuditoriaHabilitado: boolean = false;
    mostrarLeyenda: boolean = false;

    observacionEmailAuditoriaMedica: string = '';
    observacionInterna: string = '';

    selectedFiles: any[] = [];

    esSedeInscripcion: boolean = true;

    searchTerm: string = '';
    searchResults: any[] = [];
    currentSearchIndex: number = -1;
    searchableElements: any[] = [];

    habilitarGuardarObservacionInterna: boolean = false;

    datosInscripcionCompleta: any = null;

    // Mapa de etiquetas para secciones médicas
    fieldLabelMap: Record<string, string> = {
        // Síntomas y experiencias
        doloresCabeza: 'Dolores de cabeza',
        trastornosOculares: 'Trastornos oculares',
        mareosDesmayos: 'Mareos/desmayos',
        convulsiones: 'Convulsiones',
        neuralgiaNeuritis: 'Neuralgia/neuritis',
        depresion: 'Depresión',
        supuracionOidos: 'Supuración de oídos',
        resfriosFrecuentes: 'Resfríos frecuentes',
        tosCronica: 'Tos crónica',
        sudoresNocturnos: 'Sudores nocturnos',
        perdidaPeso: 'Pérdida de peso',
        doloresPecho: 'Dolores en el pecho',
        temblores: 'Temblores',
        debilidadMuscular: 'Debilidad muscular',
        faltaAire: 'Falta de aire',
        palpitaciones: 'Palpitaciones',
        acidez: 'Acidez',
        dificultadOrinar: 'Dificultad para orinar',
        sangreOrina: 'Sangre en la orina',
        articulacionesHinchadas: 'Articulaciones hinchadas',
        lumbalgia: 'Lumbalgia',
        ciatalgia: 'Ciatalgia',
        desviacionColumna: 'Desviación de columna',
        fracturas: 'Fracturas',
        traumatismos: 'Traumatismos',
        cirugias: 'Cirugías',
        internaciones: 'Internaciones',
        otros: 'Otros',

        // Antecedentes familiares
        artritisFamiliar: 'Artritis familiar',
        enfermedadesInmunologicas: 'Enfermedades inmunológicas',
        cancer: 'Cáncer',
        enfermedadCardiaca: 'Enfermedad cardíaca',
        tensionAlta: 'Tensión alta',
        enfermedadRenal: 'Enfermedad renal',
        tuberculosis: 'Tuberculosis',
        enfermedadesMentales: 'Enfermedades mentales',
        enfermedadesHereditariasGeneticas: 'Enf. hereditarias genéticas',

        // Antecedentes patológicos
        diabetes: 'Diabetes',
        hipertension: 'Hipertensión',
        alergia: 'Alergia',
        asma: 'Asma',
        calculosRenales: 'Cálculos renales',
        infeccionUrinaria: 'Infección urinaria',
        hepatitis: 'Hepatitis',
        chagas: 'Chagas',
        brucelosis: 'Brucelosis',
        toxoplasmosis: 'Toxoplasmosis',
        trastornosPsiquiatricos: 'Trastornos psiquiátricos',
        trastornosMarcha: 'Trastornos de la marcha',
        dispositivosMedicos: 'Dispositivos médicos',
        enfermedadesTransmisionSexual: 'Enf. transmisión sexual',
        alteracionesEndocrinas: 'Alteraciones endocrinas',
        artritis: 'Artritis',
        enfermedadesPiel: 'Enfermedades de la piel',
        epilepsia: 'Epilepsia',
        ulceraGastrica: 'Úlcera gástrica',
        gastritis: 'Gastritis',
        hemorroides: 'Hemorroides',
        hernias: 'Hernias',
        sinusitis: 'Sinusitis',
        cancerTumores: 'Cáncer/tumores',
        varices: 'Várices',
        discapacidad: 'Discapacidad',
        incapacidad: 'Incapacidad',
        medicoEspecialTraslado: 'Médico especial/traslado',

        // Antecedentes quirúrgicos
        traumatologica: 'Traumatológica',
        cardiaca: 'Cardíaca',
        ginecologica: 'Ginecológica',
        general: 'General',
        neuroquirurgicas: 'Neuroquirúrgicas',
        malformacionesNacimiento: 'Malformaciones de nacimiento',
        hidrocefalia: 'Hidrocefalia',
        malformacionesGeneticas: 'Malformaciones genéticas',

        // Gineco-obstétricos (subclaves)
        alteracionesMenstruales: 'Alteraciones menstruales',
        embarazos: 'Embarazos',
        patologiaMamaria: 'Patología mamaria',
    };

    constructor(
        @Inject(APP_CONFIG_OFERTAS) private iAppOfertas: IAppOfertas,
        @Inject(MAT_DIALOG_DATA) public data: string,
        public dialogRef: MatDialogRef<BandejaInscripcionesComponent>,
        private router: Router,
        private solicitudesService: SolicitudesService,
        private mediaService: MediaService,
        public dialog: MatDialog,
        private mailerService: MailerService,
        private catalogoService: CatalogoService,
        private guiMsjService: GuiMsjService,
        private userEntreUserService: UserEntreUserService,
        private usuarioService: UsuarioService,
        private actividadesService: ActividadesService,
        private pdfExportService: PdfExportService,
    ) {
        this.newState = this.solicitudesService
            .getsetNewStater()
            .subscribe((resp) => {
                this.initPostChangeStatus();
                this.newState = resp;
            });
        this.mediaService.reiniciarContadorControlUpload();
        this.subscribeAvanceUpload();
    }

    ngOnInit(): void {
        this.getDataSolicitud();
        this.cargarAdjuntoContrato();
    }

    ngOnDestroy(): void {}

    initPostChangeStatus(): void {
        this.getDataSolicitud();
        this.activarCerrarModal = true;
    }

    clearSelectionFile() {
        this.selectedFile = null;
        this.selectedFileName = '';
        this.isActive = false;
    }

    subscribeAvanceUpload() {
        this.subscriptionAvance = this.mediaService
            .getAvance()
            .subscribe((resp) => {
                if (resp) {
                    this.value = resp.value;
                } else {
                    this.value = 0;
                }
            });
    }

    async getDataSolicitud() {
        console.log(await this.getSolicitud());
        this.flagLoaded = false;
        await this.getEstadoSolicitud(await this.getSolicitud());
        await this.getArrayImgsAndFile((await this.getSolicitud()).adjuntos);
        await this.setNombresAdjuntos();
        await this.getBeneficiario(this.solicitud);
        this.observacionInterna = this.solicitud?.observacionInterna || '';
        this.habilitarBotonObservacionesInternas(this.observacionInterna);

        // Asignar datos completos de inscripción y DDJJ para los paneles
        this.datosInscripcionCompleta = {
            ...(this.solicitud.inscripcion?.contenido || {}),
            ddjj: this.solicitud.ddjj?.contenido || null
        };

        this.flagLoaded = true;
    }

    async getSolicitud(): Promise<Solicitud> {
        this.solicitud =
            await this.solicitudesService.getSolicitudSeleccionada();
        this.actividad = this.solicitud.actividad;
        this.usuario = this.solicitud.usuario;
        this.nombrePais = this.solicitud.pais.name_es;
        this.esSedeInscripcion = true;
        console.log('solicitud', this.solicitud);
        return this.solicitud;
    }

    async getBeneficiario(solicitud: Solicitud) {
        this.beneficiario =
            await this.userEntreUserService.getBeneficiario(solicitud);
    }

    async getEstadoSolicitud(solicitud: Solicitud) {
        this.activarEnEspera = true;

        console.log(
            'solicitud.lastState.numberState',
            solicitud.lastState.numberState,
        );

        switch (solicitud.lastState.numberState) {
            case 0: // PRESENTADO
                this.activarRechazar = false;
                this.activarEnRevision = true;
                this.activarEnAuditoria = false;
                this.activarAprobar = true;
                this.activarRechazar = true;
                this.flagLabelPresentado = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.pendiente;
                break;

            case 1: // DOCUMENTACION PRESENTADA
                this.activarEnAuditoria = true;
                this.activarAprobar = true;
                this.activarEnRevision = true;
                this.activarRechazar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.pendiente;
                break;

            case 2: // EN REVISIÓN
                this.flagEnRevision = true;
                this.activarEnRevision = true;
                this.activarRechazar = true;
                this.activarEnAuditoria = true;
                this.activarAprobar = true;
                this.activarRechazar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            case 3: // EN AUDITORIA MÉDICA
                this.activarEnRevision = false;
                this.activarRechazar = true;
                this.activarEnAuditoria = true;
                this.activarAprobar = true;
                this.activarRechazar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                this.flagEnAuditoria = true;
                break;

            case 4: // APROBADA
                this.activarEnRevision = false;
                this.activarAprobar = false;
                this.activarEnAuditoria = false;
                this.flagLabelAprobado = true;
                this.activarRechazar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            case 5: // RECHAZADO/ANULADO
                this.activarRechazar = false;
                this.flagLabelRechazado = true;
                this.activarEnEspera = false;
                this.activarDeshacerAnulacion = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            case 6: // EN ESPERA
                this.activarEnEspera = false;
                this.activarEnRevision = true;
                this.activarRechazar = true;
                this.activarEnAuditoria = true;
                this.activarAprobar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                this.flagLabelEnEspera = true;
                this.flagEnRevision = false;
                break;

            case 14: // INSCRIPCION PARCIAL
                this.activarEnRevision = true;
                this.activarRechazar = true;
                this.activarEnAuditoria = false;
                this.activarAprobar = true;
                this.activarEnEspera = true;
                this.flagLabelPresentado = false;
                this.flagLabelEnEspera = false;
                this.flagLabelAprobado = false;
                this.flagLabelRechazado = false;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.pendiente;
                break;

            case 15: // INSCRIPCION COMPLETA (DDJJ)
                this.activarEnRevision = true;
                this.activarRechazar = true;
                this.activarEnAuditoria = false;
                this.activarAprobar = true;
                this.activarEnEspera = true;
                this.flagLabelPresentado = false;
                this.flagLabelEnEspera = false;
                this.flagLabelAprobado = false;
                this.flagLabelRechazado = false;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            case 16: // INSCRIPCION APROBADA
                this.activarEnRevision = false;
                this.activarRechazar = false;
                this.activarEnAuditoria = false;
                this.activarAprobar = false;
                this.activarEnEspera = false;
                this.flagLabelAprobado = true;
                this.flagLabelPresentado = false;
                this.flagLabelEnEspera = false;
                this.flagLabelRechazado = false;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            default:
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.pendiente;
                break;
        }
    }

    async getArrayImgsAndFile(adjuntos: string[]) {
        console.log('Adjuntos recibidos:', adjuntos);
        this.imgs = [];
        this.files = [];
        adjuntos.forEach((element) => {
            if (element.toLowerCase().includes('.pdf')) {
                this.files.push(element);
            } else {
                this.imgs.push(element);
            }
        });
        console.log('Imagenes:', this.imgs, 'Archivos:', this.files);
    }

    verImagen(img: string) {
        const url = `${environment.urlBackend}/media/imgUserOffer/${this.usuario._id}/${img}`;
        this.dialog.open(OfertasImageViewerComponent, {
            data: {
                url: url,
                titulo: 'Visualización de Imagen'
            },
            width: 'auto',
            maxWidth: '90vw'
        });
    }

    descargarImagenPDF(img: string) {
        const url = `${environment.urlBackend}/media/image-pdf/${this.usuario._id}/${img}`;
        window.open(url, '_blank');
    }

    async setNombresAdjuntos() {
        if (!this.imgs || this.imgs.length === 0) return;

        for (const img of this.imgs) {
            try {
                const idAdjunto = img.split('.')[0];
                const docEncontrado = this.solicitud?.documentosEstadosSolicitar?.find(
                    (doc) => doc.documento?._id === idAdjunto
                );

                if (docEncontrado && docEncontrado.documento) {
                    this.nombresImagenes[img] = docEncontrado.documento.nombre;
                    continue;
                }

                let nombre = await this.actividadesService.getNombreAdjunto(img);
                if (!nombre) {
                    nombre = await this.usuarioService.getNombreAdjunto(img);
                }

                if (!nombre || idAdjunto === this.solicitud?._id) {
                    this.nombresImagenes[img] = 'Documento Extra';
                } else {
                    this.nombresImagenes[img] = nombre;
                }
            } catch (error) {
                console.error('Error resolviendo nombre para:', img, error);
                this.nombresImagenes[img] = 'Documento Extra';
            }
        }
    }

    async cargarAdjuntoContrato() {
        this.adjuntoCatalogo =
            await this.catalogoService.getFindByKey('ADJUNTO_CONTRATO');
    }

    openDialog(label: string, estado: string, idAdjunto: string): void {
        const dialogRef = this.dialog.open(UploadFileSolicitudComponent, {
            width: '800px',
            height: '800px',
            disableClose: true,
            data: {
                solicitud: this.solicitud,
                adjunto: idAdjunto,
                label,
                numberState: estado,
                labelButton: 'ENVIAR CONTRATO',
                accept: 'application/pdf',
            },
        });

        dialogRef.afterClosed().subscribe(async (result) => {
            if (result) {
                await this.refreshComponent('autorizaciones-listado');
                const messageDto = await this.mailerService.prepareMailToSend(
                    this.solicitud.usuario,
                    await this.getSolicitud(),
                    true,
                    this.adjuntoCatalogo.properties._idAdjunto,
                    'TEMPLATE_MAILER_CONTRATO',
                );
                await this.mailerService.sendMail(messageDto);
                this.dataModal = result;
            }
        });
    }

    refreshComponent(url) {
        this.router
            .navigateByUrl(url, { skipLocationChange: true })
            .then(async () => {
                await this.closeModal();
                await this.openDialogModaSolicitud();
            });
    }

    openDialogModaSolicitud(): void {
        const dialogRef = this.dialog.open(BandejaInscripcionesComponent, {
            width: '900px',
            height: '1000px',
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe(async (result) => {});
        return;
    }

    closeModal(): void {
        this.dialogRef.close();
    }

    async desactivarBotones() {
        this.activarEnRevision = false;
        this.activarEnAuditoria = false;
        this.activarRechazar = false;
        this.activarAprobar = false;
        this.activarCerrarModal = false;
        this.isCheckedAprobar = false;
        this.isCheckedRechazar = false;
        this.isCheckedEnRevision = false;
        this.activarEnEspera = false;
        this.isCheckedEnEspera = false;
    }

    async limpiarTexto() {
        this.motivoRevision = '';
        this.motivoRechazo = '';
        this.motivoEnEspera = '';
    }

    async habilitarBotonObservaciones(motivo: string) {
        this.habilitarEnviarObservacion = motivo.trim() !== '';
    }

    async actualizarEstadoSolicitud(
        _id: string,
        numberState: number,
        notificaAdmin: boolean,
        state?: string,
        notificar?: boolean,
        observaciones?: string,
        file?: string,
    ) {
        console.log(
            'Actualizando estado a:',
            numberState,
            'Nombre estado:',
            state,
        );
        console.log('Motivo proporcionado:', observaciones);

        await this.desactivarBotones();
        await this.limpiarTexto();
        this.activarDeshacerAnulacion = false;
        this.flagSpinner = true;

        try {
            const solicitudUpdated: Solicitud =
                await this.solicitudesService.updateSolicitudState(
                    _id,
                    numberState,
                    notificaAdmin,
                    state,
                    notificar,
                    observaciones,
                    file,
                );
            await this.solicitudesService.setSolicitudSeleccionada(
                solicitudUpdated,
            );
            this.flagSpinner = false;
            this.solicitudesService.setNewState(solicitudUpdated);
            this.guiMsjService.msjFormSubmit('solicitudEstadoOK');
        } catch (error) {
            this.flagSpinner = false;
            console.log(error);
        }
    }

    async deshacerAnulacion() {
        await this.actualizarEstadoSolicitud(
            this.solicitud._id,
            this.iAppOfertas.estado_2.number,
            false,
            this.iAppOfertas.estado_2.name,
            true,
            'Anulación revertida - La solicitud vuelve a revisión',
        );
    }

    get historialConUsuario(): any[] {
        return this.solicitud?.states
            ? this.solicitud.states.filter(
                  (s) =>
                      !!s.userName &&
                      s.numberState !== 0 &&
                      s.numberState !== 1,
              )
            : [];
    }

    // ---------- Métodos específicos de inscripción ----------
    async aprobarSolicitudInscripcion(): Promise<void> {
        console.log('Iniciando aprobación de inscripción');

        this.flagSpinner = true;
        const currentState = this.solicitud.lastState.numberState;
        const nextState = currentState === 14 || currentState === 15 ? 16 : 4;
        const nextStateName =
            nextState === 16
                ? this.iAppOfertas.estado_16.name
                : this.iAppOfertas.estado_4.name;
        await this.actualizarEstadoSolicitud(
            this.solicitud._id,
            nextState,
            false,
            nextStateName,
            true,
            'Inscripción APROBADA - Proceso completado',
        );
        await this.notificarAprobadosPostRegistro();
        Swal.close();
        this.dialogRef.close(true);
    }

    private esEmailValido(email: string): boolean {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    async notificarAprobadosPostRegistro(): Promise<void> {
        try {
            this.flagSpinner = true;
            this.guiMsjService.msjFormSubmit('Enviando');

            const usuariosPayload = [];
            const contenido = this.solicitud.inscripcion
                .contenido as unknown as InscripcionOs;
            const datosTitular = contenido.datosDelTitular;
            const familiares = contenido.familiares || [];

            const sedeTitular = this.usuario.signoSedes && this.usuario.signoSedes[0];
            const sedeCodigoTitular = sedeTitular?.codigoGecro || '000';
            const sedeNombreTitular = sedeTitular?.nombre || 'SEDE NO ESPECIFICADA';

            usuariosPayload.push({
                id: this.solicitud.usuario._id,
                email: this.solicitud.usuario.email,
                nombre: datosTitular.nombre,
                apellido: datosTitular.apellido,
                username: `${datosTitular.nombre}.${datosTitular.apellido}`
                    .toLowerCase()
                    .replace(/\s+/g, ''),
                passwordTemporal: datosTitular.numeroDocumento.toString(),
                notificar: true,
                sedeCodigo: sedeCodigoTitular,
                sedeNombre: sedeNombreTitular,
            });

            for (const familiar of familiares) {
                if (familiar.email && this.esEmailValido(familiar.email)) {
                    let usuarioFamiliarId = `familiar-${familiar.numeroDocumento}`;
                    let sedeCodigoFamiliar = '000';
                    let sedeNombreFamiliar = 'SEDE NO ESPECIFICADA';
                    try {
                        const usuarioFamiliar = await this.usuarioService.getFindOneByIdentification(
                            familiar.numeroDocumento.toString(),
                        );
                        if (usuarioFamiliar) {
                            usuarioFamiliarId = usuarioFamiliar._id;
                            if (usuarioFamiliar.signoSedes && usuarioFamiliar.signoSedes[0]) {
                                sedeCodigoFamiliar = usuarioFamiliar.signoSedes[0].codigoGecro || '000';
                                sedeNombreFamiliar = usuarioFamiliar.signoSedes[0].nombre || 'SEDE NO ESPECIFICADA';
                            }
                        }
                    } catch (error) { }
                    usuariosPayload.push({
                        id: usuarioFamiliarId,
                        email: familiar.email,
                        nombre: familiar.nombre,
                        apellido: familiar.apellido,
                        username: `${familiar.nombre}.${familiar.apellido}`
                            .toLowerCase()
                            .replace(/\s+/g, ''),
                        passwordTemporal: familiar.numeroDocumento.toString(),
                        notificar: true,
                        sedeCodigo: sedeCodigoFamiliar,
                        sedeNombre: sedeNombreFamiliar,
                    });
                }
            }

            const payload = {
                usuarios: usuariosPayload,
                observacion: `Inscripción aprobada - Solicitud ${this.solicitud._id}`,
                bccAdmin: false,
            };

            const resp: any = await this.solicitudesService.notificarAprobados(payload);
            const data = resp && resp.response ? resp.response : resp;

            Swal.fire({
                icon: 'success',
                title: 'Notificación enviada',
                html: `
                    <div style="text-align:left">
                    <div><b>Total:</b> ${data?.total ?? '-'}</div>
                    <div><b>Notificados:</b> ${data?.notificados ?? '-'}</div>
                    <div><b>Omitidos:</b> ${data?.omitidos ?? '-'}</div>
                    </div>
                `,
            });
        } catch (error) {
            console.error('Error en notificarAprobadosPostRegistro:', error);
            const msg = error?.message || 'Error al enviar la notificación';
            Swal.fire({ icon: 'error', title: 'Ups', text: msg });
        } finally {
            this.flagSpinner = false;
        }
    }

    copiarDNI(dni: string): void {
        navigator.clipboard.writeText(dni).then(() => {
            this.guiMsjService.msjFormSubmit('DNI copiado al portapapeles');
        });
    }

    async guardarObservacionInterna(): Promise<void> {
        try {
            this.flagSpinner = true;
            const respuesta = await this.solicitudesService.updateSolicitudObservacionInterna(
                this.solicitud._id,
                this.solicitud,
                this.observacionInterna,
            );
            if (respuesta) {
                this.solicitud = respuesta;
                this.solicitudesService.setSolicitudSeleccionada(respuesta);
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Observación interna guardada',
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                    toast: true,
                    background: '#28a745',
                    iconColor: 'white',
                });
            }
        } catch (error) {
            console.error('Error al guardar observación interna:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo guardar la observación interna.',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#dc3545',
            });
        } finally {
            this.flagSpinner = false;
        }
    }

    async habilitarBotonObservacionesInternas(motivo: string) {
        this.habilitarGuardarObservacionInterna = motivo.trim() !== '';
    }

    formatearFecha(fecha: string | Date): string {
        if (!fecha) return 'No especificada';
        return new Date(fecha).toLocaleDateString('es-AR');
    }

    formatearFechaHora(fecha: string | Date): string {
        if (!fecha) return 'No especificada';
        const d = new Date(fecha);
        const dia = d.getDate().toString().padStart(2, '0');
        const mes = (d.getMonth() + 1).toString().padStart(2, '0');
        const anio = d.getFullYear();
        const horas = d.getHours().toString().padStart(2, '0');
        const minutos = d.getMinutes().toString().padStart(2, '0');
        return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
    }

    // Helper para mostrar sexo
    mostrarSexo(sexo: any): string {
        if (typeof sexo === 'number') {
            switch (sexo) {
                case Sexo.Masculino: return 'Masculino';
                case Sexo.Femenino: return 'Femenino';
                default: return 'No especificado';
            }
        } else if (typeof sexo === 'string') {
            return sexo;
        }
        return 'No especificado';
    }

    // Helper para mostrar estado civil
    mostrarEstadoCivil(estado: any): string {
        if (typeof estado === 'number') {
            switch (estado) {
                case EstadoCivil.Soltero: return 'Soltero/a';
                case EstadoCivil.Casado: return 'Casado/a';
                case EstadoCivil.Divorciado: return 'Divorciado/a';
                case EstadoCivil.Viudo: return 'Viudo/a';
                default: return 'No especificado';
            }
        } else if (typeof estado === 'string') {
            return estado;
        }
        return 'No especificado';
    }

    // Helper para mostrar régimen laboral
    mostrarRegimenLaboral(regimen: any): string {
        if (typeof regimen === 'number') {
            switch (regimen) {
                case RegimenLaboral.General: return 'General';
                case RegimenLaboral.Monotributo: return 'Monotributo';
                case RegimenLaboral.ServicioDomestico: return 'Servicio Doméstico';
                default: return 'No especificado';
            }
        } else if (typeof regimen === 'string') {
            return regimen;
        }
        return 'No especificado';
    }

    // Helper para mostrar tipo documento
    mostrarTipoDocumento(tipo: any): string {
        if (typeof tipo === 'number') {
            switch (tipo) {
                case TipoDocumento.DNI: return 'DNI';
                case TipoDocumento.CI: return 'CI';
                case TipoDocumento.LE: return 'LE';
                case TipoDocumento.LC: return 'LC';
                default: return 'No especificado';
            }
        } else if (typeof tipo === 'string') {
            return tipo;
        }
        return 'No especificado';
    }

    // Helper para mostrar nacionalidad
    mostrarNacionalidad(nacionalidad: any): string {
        if (typeof nacionalidad === 'number') {
            switch (nacionalidad) {
                case Nacionalidad.Argentino: return 'Argentino';
                case Nacionalidad.Extranjero: return 'Extranjero';
                default: return 'No especificada';
            }
        } else if (typeof nacionalidad === 'string') {
            return nacionalidad;
        }
        return 'No especificada';
    }

    mostrarFactorRh(factorRh: boolean): string {
        return factorRh ? 'Positivo (+)' : 'Negativo (-)';
    }

    mostrarAntecedentesMedicos(antecedentes: any): string {
        if (!antecedentes) return 'No especificado';
        let info = '';
        if (antecedentes.atencionMedica?.bajoAtencion !== undefined) {
            info += `Bajo atención médica: ${this.mostrarSiNo(antecedentes.atencionMedica.bajoAtencion)}`;
            if (antecedentes.atencionMedica.bajoAtencion) {
                if (antecedentes.atencionMedica.medicoAtiende) info += ` - ${antecedentes.atencionMedica.medicoAtiende}`;
                if (antecedentes.atencionMedica.enfermedad) info += ` - ${antecedentes.atencionMedica.enfermedad}`;
            }
        }
        if (antecedentes.medicamentosUltimos6Meses) {
            if (info) info += ' | ';
            info += `Medicamentos últimos 6 meses: ${antecedentes.medicamentosUltimos6Meses}`;
        }
        if (antecedentes.motivoConsultaActual !== undefined) {
            if (info) info += ' | ';
            info += `Motivo consulta actual: ${this.mostrarSiNo(antecedentes.motivoConsultaActual)}`;
        }
        return info || 'Sin antecedentes médicos relevantes declarados';
    }

    mostrarHabitosFisiologicos(habitos: any): string {
        if (!habitos) return 'No especificado';
        let info = '';
        if (habitos.alimentacion) {
            if (habitos.alimentacion.comidasDiarias !== undefined) {
                info += `Comidas diarias: ${this.mostrarSiNo(habitos.alimentacion.comidasDiarias)}`;
            }
            if (habitos.alimentacion.queAlimentacion) {
                info += info ? ' | ' : '';
                info += `Alimentación: ${habitos.alimentacion.queAlimentacion}`;
            }
            if (habitos.alimentacion.incluyeDesayuno !== undefined) {
                info += info ? ' | ' : '';
                info += `Incluye desayuno: ${this.mostrarSiNo(habitos.alimentacion.incluyeDesayuno)}`;
            }
        }
        if (habitos.sueno) {
            if (info) info += ' | ';
            if (habitos.sueno.suenoTranquilo !== undefined) {
                info += `Sueño tranquilo: ${this.mostrarSiNo(habitos.sueno.suenoTranquilo)}`;
            }
            if (habitos.sueno.horasSueno) {
                info += info.endsWith('Sí') || info.endsWith('No') ? ' ' : ' | ';
                info += `(${habitos.sueno.horasSueno} horas)`;
            }
        }
        if (habitos.constipacion !== undefined) {
            if (info) info += ' | ';
            info += `Constipación: ${this.mostrarSiNo(habitos.constipacion)}`;
        }
        if (habitos.deporte) {
            if (info) info += ' | ';
            if (habitos.deporte.realizaDeporte !== undefined) {
                info += `Realiza deporte: ${this.mostrarSiNo(habitos.deporte.realizaDeporte)}`;
            }
            if (habitos.deporte.cualDeporte) {
                info += info.endsWith('Sí') || info.endsWith('No') ? ' ' : ' | ';
                info += `(${habitos.deporte.cualDeporte})`;
            }
        }
        return info || 'Sin hábitos fisiológicos relevantes declarados';
    }

    mostrarHabitosToxicos(habitos: any): string {
        if (!habitos) return 'No especificado';
        let info = '';
        if (habitos.fumador?.fuma !== undefined) {
            info += `Fuma: ${this.mostrarSiNo(habitos.fumador.fuma)}`;
            if (habitos.fumador.fuma && habitos.fumador.cantidadPorDia) {
                info += ` (${habitos.fumador.cantidadPorDia} por día)`;
            }
        }
        if (habitos.alcohol?.tomaAlcohol !== undefined) {
            if (info) info += ' | ';
            info += `Alcohol: ${this.mostrarSiNo(habitos.alcohol.tomaAlcohol)}`;
            if (habitos.alcohol.tomaAlcohol && habitos.alcohol.cuales) {
                info += ` (${habitos.alcohol.cuales})`;
            }
        }
        if (habitos.drogas?.consumeDrogas !== undefined) {
            if (info) info += ' | ';
            info += `Drogas: ${this.mostrarSiNo(habitos.drogas.consumeDrogas)}`;
            if (habitos.drogas.consumeDrogas && habitos.drogas.cuales) {
                info += ` (${habitos.drogas.cuales})`;
            }
        }
        if (habitos.automedicacion?.seAutomedica !== undefined) {
            if (info) info += ' | ';
            info += `Automedicación: ${this.mostrarSiNo(habitos.automedicacion.seAutomedica)}`;
            if (habitos.automedicacion.seAutomedica && habitos.automedicacion.medicacion) {
                info += ` (${habitos.automedicacion.medicacion})`;
            }
        }
        return info || 'Sin hábitos tóxicos relevantes declarados';
    }

    mostrarAntecedentesGinecoObstetricos(antecedentes: any): string {
        if (!antecedentes) return 'No especificado';
        let info = '';
        if (antecedentes.alteracionesMenstruales?.tiene !== undefined) {
            info += `Alteraciones menstruales: ${this.mostrarSiNo(antecedentes.alteracionesMenstruales.tiene)}`;
            if (antecedentes.alteracionesMenstruales.tiene && antecedentes.alteracionesMenstruales.primeraMenstruacionEdad) {
                info += ` (1ra menstruación: ${antecedentes.alteracionesMenstruales.primeraMenstruacionEdad} años)`;
            }
        }
        if (antecedentes.embarazos?.tuvo !== undefined) {
            if (info) info += ' | ';
            info += `Embarazos: ${this.mostrarSiNo(antecedentes.embarazos.tuvo)}`;
            if (antecedentes.embarazos.tuvo && antecedentes.embarazos.cantidad) {
                info += ` (${antecedentes.embarazos.cantidad})`;
            }
        }
        if (antecedentes.patologiaMamaria?.tiene !== undefined) {
            if (info) info += ' | ';
            info += `Patología mamaria: ${this.mostrarSiNo(antecedentes.patologiaMamaria.tiene)}`;
            if (antecedentes.patologiaMamaria.tiene && antecedentes.patologiaMamaria.cuales) {
                info += ` (${antecedentes.patologiaMamaria.cuales})`;
            }
        }
        return info || 'Sin antecedentes gineco-obstétricos relevantes declarados';
    }

    // Nuevo método para obtener etiqueta
    formatKey(key: string): string {
        return this.fieldLabelMap[key] || key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, s => s.toUpperCase())
            .trim();
    }

    // Mostrar valor booleano
    mostrarSiNo(valor: boolean): string {
        return valor ? 'Sí' : 'No';
    }

    // Obtener detalle según tipo de objeto
    obtenerDetalle(item: any): string {
        if (!item?.tiene) return '';
        let detalle = item.cual || item.cuales || item.quien || '';
        return detalle;
    }

    // Helpers para contar (ya no se usan en la vista pero se dejan por si acaso)
    contarAntecedentesPatologicos(antecedentes: any): number {
        if (!antecedentes) return 0;
        return Object.values(antecedentes).filter((antecedente: any) => antecedente?.tiene).length;
    }

    contarSintomas(sintomas: any): number {
        if (!sintomas) return 0;
        return Object.values(sintomas).filter((sintoma: any) => sintoma?.tiene).length;
    }

    objectKeys(obj: any): string[] {
        return obj ? Object.keys(obj) : [];
    }

    // Helper para mostrar parentesco
    mostrarParentesco(parentesco: any): string {
        if (typeof parentesco === 'number') {
            switch (parentesco) {
                case Parentesco.Esposo: return 'Esposo/a';
                case Parentesco.Concubino: return 'Concubino/a';
                case Parentesco.Hijo: return 'Hijo/a';
                default: return 'No especificado';
            }
        } else if (typeof parentesco === 'string') {
            return parentesco;
        }
        return 'No especificado';
    }

    mostrarGrupoSanguineo(grupo: any): string {
        if (typeof grupo === 'string') {
            return grupo;
        }
        return 'No especificado';
    }

    /**
     * Exporta dos PDFs de forma secuencial:
     * 1. PDF de documentación (imágenes y archivos) usando pdf-lib.
     * 2. PDF de Inscripción y DDJJ capturando el div #export-inscripcion-ddjj.
     */
    async exportarPDFs(): Promise<void> {
        if (!this.flagLoaded || !this.solicitud || !this.usuario) {
            return;
        }

        // --- nombre base para los archivos ---
        const contenido = this.solicitud.inscripcion?.contenido as any;
        const titular = contenido?.datosDelTitular;
        let baseName = `${this.solicitud._nro}`;
        if (titular?.apellido && titular?.nombre) {
            const formatName = (str: string): string =>
                str.trim().split(/\s+/).map(p => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()).join('-');
            const apellido = formatName(titular.apellido);
            const nombre   = formatName(titular.nombre);
            baseName = `${apellido}-${nombre}-${this.solicitud._nro}`;
        }

        // ----- PDF 1: Documentación (adjuntos) -----
        try {
            await this.pdfExportService.generateAttachmentsPDF(
                this.solicitud,
                this.imgs,
                this.files,
                this.usuario._id,
                this.nombresImagenes,
                `${baseName}-Documentacion.pdf`
            );
        } catch (error) {
            console.error('Error al generar PDF de documentación:', error);
        }

        // ----- PDF 2: Inscripción y DDJJ (múltiples páginas desde el contenedor oculto) -----
        const contenedor = document.getElementById('export-inscripcion-ddjj-pdf');
        if (!contenedor) {
            console.warn('No se encontró el contenedor oculto para exportar');
            return;
        }

        // Mostramos el contenedor para que html2canvas pueda renderizarlo
        contenedor.style.display = 'block';
        await new Promise(resolve => setTimeout(resolve, 300)); // esperar render

        try {
            const paginas = contenedor.querySelectorAll<HTMLElement>('.page-a4');
            if (paginas.length === 0) {
                console.warn('No se encontraron páginas .page-a4 dentro del contenedor');
                return;
            }

            const pdf = new jsPDF('p', 'mm', 'a4');
            let primeraPagina = true;

            for (let i = 0; i < paginas.length; i++) {
                const pagina = paginas[i];
                // Asegurar que sea visible dentro del contenedor
                pagina.style.display = 'block';
                const canvas = await html2canvas(pagina, {
                    scale: 2,
                    useCORS: true,
                    logging: false
                });

                const imgData = canvas.toDataURL('image/png');
                const imgWidth = 210;  // mm
                const pageHeight = 297;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;

                if (primeraPagina) {
                    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
                    primeraPagina = false;
                } else {
                    pdf.addPage();
                    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
                }

                // Si la imagen es más alta que una página A4, jsPDF la recorta; 
                // en nuestro diseño cada .page-a4 debería caber en una sola página.
            }

            pdf.save(`${baseName}-Inscripcion-y-DDJJ.pdf`);
        } catch (error) {
            console.error('Error al generar PDF de inscripción:', error);
        } finally {
            contenedor.style.display = 'none';
        }
    }
}   